module.exports = __webpack_public_path__ + "img/ED1.0742ed51.jpeg";